module.exports = __webpack_public_path__ + "static/media/medium-lg-2.269c71f6.jpg";